var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSegmentLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logosandtypes_com",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill-rule:evenodd;clip-rule:evenodd;fill:#6bac92}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .2h150v150H0V.2z",
    fill: "none",
    id: "Layer_2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Segment"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.8 59.8c-.3-.6-.4-1.2-.3-1.9C16.9 44.6 24.4 32.7 35 24 51.8 10.1 74.6 6.1 95.2 13.3c.6.2 1.1.7 1.4 1.3.2.6.2 1.3 0 1.9l-3.1 8.2c-.4 1.2-1.8 1.9-3 1.4-16.1-5.6-34-2.4-47.2 8.4-8.2 6.9-14.1 16.2-16.7 26.6-.3 1-1.2 1.8-2.3 1.8h-.5l-8.5-2c-.6-.2-1.2-.6-1.5-1.1M136.5 80.2c-.4-.5-1-.8-1.6-.9l-8.6-.9c-1.3-.1-2.4.8-2.6 2.1-1.5 11.7-7.2 22.6-15.9 30.6-13.7 12.7-33.5 16.5-50.9 9.8-1.2-.5-2.6.1-3 1.3l-3.4 8.2c-.3.6-.3 1.3 0 1.9.2.6.7 1.1 1.3 1.3 7.2 2.8 14.9 4.3 22.7 4.3 15.7 0 30.8-5.9 42.3-16.6 11.1-10.3 18.2-24.2 20.1-39.2.1-.7-.1-1.4-.4-1.9M88.7 92.1v-8.9c0-1.3-1.1-2.4-2.4-2.4H15.6c-1.3 0-2.4 1.1-2.4 2.4v8.9c0 1.3 1.1 2.4 2.4 2.4h70.7c1.4.1 2.4-1 2.4-2.4M61.5 51.2V60c0 1.3 1 2.4 2.4 2.4h70.7c1.3 0 2.4-1.1 2.4-2.4v-8.9c0-1.3-1.1-2.3-2.4-2.3H63.9c-1.3 0-2.4 1.1-2.4 2.4M113.2 21.8c-4-.1-7.3 3.1-7.4 7.1-.1 4 3.1 7.3 7.1 7.4 4 .1 7.3-3.1 7.4-7.1v-.1c.1-4-3.1-7.2-7.1-7.3M34.5 109.5c-4-.1-7.3 3.1-7.4 7.1-.1 4 3.1 7.3 7.1 7.4 4 .1 7.3-3.1 7.4-7.1v-.1c.1-4.1-3.1-7.3-7.1-7.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentLogo);
export default __webpack_public_path__ + "static/media/Segment-logo.7db5793fa526a039ad0ce44997055993.svg";
export { ForwardRef as ReactComponent };